import create from 'zustand';
import { persist } from 'zustand/middleware';

export type LocaleCode = 'en' | 'is' | 'dk';

export const adminSitelanguages = ['en', 'is'] as const;
export type AdminSiteLanguageType = (typeof adminSitelanguages)[number];

export const careerSitelanguages = ['en', 'is', 'pl', 'no', 'sv', 'fr'] as const;

export type CareerSiteLanguageType = (typeof careerSitelanguages)[number];

type LocaleStoreState = {
  locale: LocaleCode;
};

const defaultState: LocaleStoreState = {
  locale: 'en',
};

const createPersistLocaleStore = (persistKey: string) =>
  create(persist(() => defaultState, { name: persistKey }));

const createSimpleLocaleStore = () => create(() => defaultState);

export const createLocaleStore = (persistKey?: string) => {
  const useStore = persistKey ? createPersistLocaleStore(persistKey) : createSimpleLocaleStore();
  const setLocale = (locale: LocaleCode) => useStore.setState(() => ({ locale, current: locale }));
  const getLocale = () => useStore.getState().locale;

  return { useStore, setLocale, getLocale };
};
